<template>
  <div
    class="tab-item active"
    data-tab="interviews"
  >
    <div class="block block-slider">
      <div class="block__headline">
        <div class="block__title headline-1">
          <i class="icon-grp-2 block__icon"></i>
          Interviews
        </div>
        <div class="block__nav">
          <a
            href="#"
            class="headline-3"
          >All interviews</a>
          <div class="block-slider__nav">
            <i class="block-slider__nav-prev block__icon icon-arrow-left"></i>
            <i class="block-slider__nav-next block__icon icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-2.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">A Q&A with Dapper Labs</h3>
              <p class="block-item__description">Lorem ipsum dolor sit amet consectetur. Urna in
                bibendum suspendisse magna. Elementum iaculis</p>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-2.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">Lorem ipsum dolor sit amet consectetur.
                Urna in bibendum </h3>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-2.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">A Q&A with Dapper Labs</h3>
              <p class="block-item__description">Lorem ipsum dolor sit amet consectetur. Urna in
                bibendum suspendisse magna. Elementum iaculis</p>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-2.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">Lorem ipsum dolor sit amet consectetur.
                Urna in bibendum </h3>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-1.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">A Q&A with Dapper Labs</h3>
              <p class="block-item__description">Lorem ipsum dolor sit amet consectetur. Urna in
                bibendum suspendisse magna. Elementum iaculis</p>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-3.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">Lorem ipsum dolor sit amet consectetur.
                Urna in bibendum </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block block-slider">
      <div class="block__headline">
        <div class="block__title headline-1">
          <i class="icon-grp-8 block__icon"></i>
          Video reviews
        </div>
        <div class="block__nav">
          <a
            href="#"
            class="headline-3"
          >All video</a>
          <div class="block-slider__nav">
            <i class="block-slider__nav-prev block__icon icon-arrow-left"></i>
            <i class="block-slider__nav-next block__icon icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-2.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">A Q&A with Dapper Labs</h3>
              <p class="block-item__description">Lorem ipsum dolor sit amet consectetur. Urna in
                bibendum suspendisse magna. Elementum iaculis</p>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-2.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">Lorem ipsum dolor sit amet consectetur.
                Urna in bibendum </h3>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-2.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">A Q&A with Dapper Labs</h3>
              <p class="block-item__description">Lorem ipsum dolor sit amet consectetur. Urna in
                bibendum suspendisse magna. Elementum iaculis</p>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-2.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">Lorem ipsum dolor sit amet consectetur.
                Urna in bibendum </h3>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-1.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">A Q&A with Dapper Labs</h3>
              <p class="block-item__description">Lorem ipsum dolor sit amet consectetur. Urna in
                bibendum suspendisse magna. Elementum iaculis</p>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="block-item">
            <div class="block-item__image">
              <img
                src="./assets/images/jpg/cat-3.jpg"
                alt=""
                class="img img--cover"
              >
            </div>
            <div class="block-item__body">
              <h3 class="block-item__title headline-2">Lorem ipsum dolor sit amet consectetur.
                Urna in bibendum </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>